export default __webpack_public_path__ + "static/media/colorTelegram.0c7efc02.svg";